const setChannel = (state, payload) => {
  state.channel = payload
}

export default {
  setChannel
}
